import { supabase } from '../api/supabase'

// "Prove it does not exist before you create it." Every place that can create a company asks the DATABASE (fresh query, never a
// list loaded earlier) whether a company like this already exists, and shows what it found. Two companies with the same name are
// the mistake the whole address work exists to stop; a duplicate LANDR is also what a "+ Create" on a dropdown that merely failed
// to list it used to produce.

import { normalizeForMatch, rankExisting, type ExistingCompany } from './existingCompanyMatch'
export type { ExistingCompany } from './existingCompanyMatch'

const clean = (s: string): string => s.replace(/[%,()*\\]/g, ' ').replace(/\s+/g, ' ').trim()

// Fresh query. Failure is NOT swallowed: if the check cannot run, creating is refused (the caller shows the error).
export async function findExistingCompanies(typedName: string, typedCode?: string | null): Promise<ExistingCompany[]> {
  const full = clean(typedName)
  const firstWord = clean(normalizeForMatch(typedName).split(' ')[0] ?? '')
  const filters: string[] = []
  if (full.length >= 2) filters.push(`name.ilike.%${full}%`)
  if (firstWord.length >= 3) filters.push(`name.ilike.%${firstWord}%`)
  const code = clean(typedCode ?? '')
  if (code) filters.push(`code.ilike.${code}`)
  if (full) filters.push(`code.ilike.${full.replace(/\s/g, '')}`)
  if (filters.length === 0) return []
  const { data, error } = await supabase.from('customers').select('id, code, name, is_active').or(filters.join(',')).limit(200)
  if (error) throw new Error(`Could not check whether this company already exists: ${error.message}`)
  return rankExisting(typedName, typedCode, (data ?? []) as ExistingCompany[])
}
